/**
 * This file is part of vue-photoswipe.
 * @link     : https://zhaiyiming.com/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 TINYMINS.
 */

import photoswipe from './dist/photoswipe';

export default photoswipe;
